import React from 'react';
import SetupDesks from '../../../../presenters/SetupDesks';
import styles from './index.module.scss';

const Body = () => {
  return (
    <div className={styles.root}>
      <SetupDesks />
    </div>
  );
};

export default Body;
